import { ReactNode } from "react";
import { Box, Button, DialogProps, Stack, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import { BaseModal } from "./BaseModal";
import LoadingButton from "../Button/LoadingButton";

type DeleteConfirmModalProps<T> = {
  label: string;
  data: T;
  format: (data: T) => string;
  warningMessage?: ReactNode;
  open: boolean;
  onClose: () => void;
  maxWidth?: DialogProps["maxWidth"];
  onConfirm: () => void;
  isConfirming: boolean;
};

function DeleteConfirmModal<T>({
  label,
  data,
  format,
  warningMessage,
  open,
  onClose,
  maxWidth,
  onConfirm,
  isConfirming,
}: DeleteConfirmModalProps<T>) {
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      title={
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningAmberIcon color="error" sx={{ fontSize: 28 }} />
          <Typography>{`${label}の削除`}</Typography>
        </Box>
      }
      children={
        <>
          <Typography variant="body2">
            {`${format(data)} を削除します。`}
            <br />
            よろしいですか？
          </Typography>
          {warningMessage}
        </>
      }
      actions={
        <Stack direction={"row"} spacing={2}>
          <Button disabled={isConfirming} variant="outlined" onClick={onClose}>
            キャンセル
          </Button>
          <LoadingButton
            isLoading={isConfirming}
            color="error"
            variant="contained"
            onClick={onConfirm}
          >
            削除
          </LoadingButton>
        </Stack>
      }
    />
  );
}

export default DeleteConfirmModal;
